import { AppDispatch } from "../app/store";
import { resetError, setError } from "../slices/error";

export const showError = (dispatch: AppDispatch, errorMessage: string) => {
  dispatch(setError(errorMessage));
  setTimeout(() => {
    dispatch(resetError());
  }, 3000);
};
